module.exports = __webpack_public_path__ + "static/media/bryndwyr-1.116634a8.jpg";